import { LegacyPhotosLinkedToAssetEvent } from '../event/legacy-photos-linked-to-asset.event';
const legacyPhotosLinkedToAssetProjections = {
    [LegacyPhotosLinkedToAssetEvent.name]: (_event, state) => ({
        ...state,
    }),
};
export default legacyPhotosLinkedToAssetProjections;
//# sourceMappingURL=legacy-photos-linked-to-asset.projection.js.map